import { Component, OnInit, inject } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { PageTitleService } from '../../core/services/page-title.service';
import { CounselService } from '../../core/services/counsel.service';
import { MemberApiService } from '../../core/services/member-api.service';

@Component({
    selector: 'app-program-list',
    imports: [],
    templateUrl: './program-list.component.html'
})
export class ProgramListComponent implements OnInit {
  private pageTitle = inject(PageTitleService);
  private counselService = inject(CounselService);
  private memberApi = inject(MemberApiService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  items: any[] = [];
  studio: any = {};
  isDisabledDownload = false;
  level = 0;

  async ngOnInit(): Promise<void> {
    this.level = Number(this.route.snapshot.params['level']);
    this.pageTitle.set('fa s-icon-clinical_notes', `プログラム ステップ${this.level}`);
    const [data, member] = await Promise.all([
      this.counselService.getTrainingProgramList(),
      this.memberApi.getOne('self'),
    ]);
    this.studio = member?.studio ?? {};
    if (Array.isArray(data)) {
      this.items = data.filter((v: any) => v.level === this.level);
    }
  }

  async download(uploadedPdf: string | null | undefined, trainingName: string): Promise<void> {
    if (this.isDisabledDownload) return;
    if (!uploadedPdf) return;
    this.isDisabledDownload = true;
    try {
      const result = await this.counselService.getTrainingPdf(uploadedPdf);
      if (!result?.data) return;
      const u8 = new Uint8Array(result.data);
      const blob = new Blob([u8], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `トレーニング_ステップ${this.level}_${trainingName}.pdf`;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => window.URL.revokeObjectURL(url), 200);
      document.body.removeChild(a);
    } finally {
      this.isDisabledDownload = false;
    }
  }

  getPdf(item: any): string | null {
    const machine = Number(this.studio?.isMachineInstalled ?? this.studio?.is_machine_installed ?? 0);
    const keys = machine > 0
      ? [`uploadedPdf${machine}`, `uploaded_pdf${machine}`, `uploaded_pdf_${machine}`, 'uploadedPdf', 'uploaded_pdf']
      : ['uploadedPdf', 'uploaded_pdf'];
    for (const key of keys) {
      const value = item?.[key];
      // The API may return the PDF id as a number; the old PJ passed it through untyped.
      if (typeof value === 'string' && value.trim()) return value;
      if (typeof value === 'number' && Number.isFinite(value)) return String(value);
    }
    return null;
  }
}
